(function() {
    'use strict';

    angular
        .module('app.usuarios')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/usuarios',
                config: {
                    templateUrl: 'app/usuarios/usuarios.html',
                    controller: 'Usuarios',
                    controllerAs: 'vm',
                    title: 'Usuarios',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-login"></i> login'
                    }
                }
            },
            {
                url: '/editar-usuario/:id?',
                config: {
                    templateUrl: 'app/usuarios/editarUsuarios.html',
                    controller: 'EditarUsuario',
                    controllerAs: 'vm',
                    title: 'EditarUsuarios',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-login"></i> login'
                    }
                }
            },
            {
                url: '/cambiar-password/:id/:nombre?',
                config: {
                    templateUrl: 'app/usuarios/cambiarPassword.html',
                    controller: 'CambiarPassword',
                    controllerAs: 'vm',
                    title: 'CambiarPassword'
                }
            }
        ];
    }
})();
